import React from "react";
import PanelLayout from "../components/PanelLayout";
import "./styles/MySuscription.css";
import { Translate, I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import * as actions_suscription from "../redux/actions/suscriptionPlanActions";
import { hasActiveSubscriptionPlan } from "../assets/subscriptionUtils";

const AVAILABLE_PLANS = [
  {
    value: 15,
    price: 15,
    period: "onepay",
    tier: "onepay",
    features: ["one_pay1", "one_pay2", "one_pay3", "one_pay4", "one_pay5"],
    cta: "one_pay_pay",
    action: "onepay",
  },
  {
    value: 10,
    price: 10,
    period: "monthly",
    tier: "basic",
    recommended: true,
    features: [
      "suscription5",
      "suscription2",
      "suscription8",
      "suscription3",
      "suscription4",
    ],
    cta: "suscription_subscribe",
    action: "subscription",
  },
  {
    value: 100,
    price: 100,
    period: "yearly",
    tier: "basic",
    features: [
      "suscription1",
      "suscription2",
      "suscription8",
      "suscription3",
      "suscription4",
    ],
    cta: "suscription_subscribe",
    action: "subscription",
  },
  {
    value: 20,
    price: 20,
    period: "monthly",
    tier: "premium",
    features: [
      "suscription5",
      "suscription7",
      "suscription8",
      "suscription3",
      "suscription4",
    ],
    cta: "suscription_subscribe",
    action: "subscription",
  },
  {
    value: 200,
    price: 200,
    period: "yearly",
    tier: "premium",
    features: [
      "suscription1",
      "suscription7",
      "suscription8",
      "suscription3",
      "suscription4",
    ],
    cta: "suscription_subscribe",
    action: "subscription",
  },
];

const PERIOD_LABELS = {
  monthly: "suscription_monthly",
  yearly: "suscription_yearly",
  onepay: "one_pay",
};

function PlanCard({ plan, onSelect }) {
  const periodClass = `subscription-plan-period--${plan.period}`;
  const cardClass = [
    "subscription-plan-card",
    plan.tier === "premium" ? "subscription-plan-card--premium" : "",
    plan.recommended ? "subscription-plan-card--recommended" : "",
  ]
    .filter(Boolean)
    .join(" ");
  const ctaClass =
    plan.tier === "premium"
      ? "subscription-plan-cta subscription-plan-cta--premium"
      : plan.tier === "onepay"
        ? "subscription-plan-cta subscription-plan-cta--onepay"
        : plan.recommended
          ? "subscription-plan-cta subscription-plan-cta--recommended"
          : "subscription-plan-cta subscription-plan-cta--primary";

  return (
    <article className={cardClass}>
      <div className="subscription-plan-card-top">
        <div>
          {plan.recommended && (
            <span className="subscription-plan-badge">
              <Translate value="suscription_recommended" />
            </span>
          )}
          <span className={`subscription-plan-period ${periodClass}`}>
            <Translate value={PERIOD_LABELS[plan.period]} />
          </span>
          <h2 className="subscription-plan-name">
            <Translate value="suscription_mine" />
          </h2>
        </div>
        <div className="subscription-plan-price-block">
          <span className="subscription-plan-price">${plan.price}</span>
          <span className="subscription-plan-currency">USD</span>
        </div>
      </div>

      <div className="subscription-plan-card-body">
        <ul className="subscription-plan-features">
          {plan.features.map((featureKey) => (
            <li key={featureKey}>
              <Translate value={featureKey} />
            </li>
          ))}
        </ul>
      </div>

      <div className="subscription-plan-card-footer">
        <button
          type="button"
          className={ctaClass}
          onClick={() => onSelect(plan)}
        >
          <Translate value={plan.cta} />
        </button>
      </div>
    </article>
  );
}

function ActivePlanCard({ suscription, onUnsubscribe }) {
  const isOneTime = suscription.Id === 2;

  return (
    <article className="subscription-plan-card subscription-plan-card--active">
      <div className="subscription-plan-card-top">
        <div>
          <span className="subscription-plan-period subscription-plan-period--active">
            <Translate value="suscription_active" />
          </span>
          <h2 className="subscription-plan-name">{suscription.Name}</h2>
        </div>
      </div>

      <div className="subscription-plan-card-body">
        <div
          className="subscription-plan-description"
          dangerouslySetInnerHTML={{
            __html: suscription.Description,
          }}
        />
        <p className="subscription-plan-meta">
          <Translate value={isOneTime ? "expire" : "renewal"} />:{" "}
          <strong>{suscription.PlanEnd}</strong>
        </p>
      </div>

      <div className="subscription-plan-card-footer">
        <button
          type="button"
          className="subscription-plan-cta subscription-plan-cta--danger"
          onClick={onUnsubscribe}
        >
          <Translate value="suscription_unsubscribe" />
        </button>
      </div>
    </article>
  );
}

class MySuscription extends React.Component {
  componentDidMount() {
    this.fetchSuscriptionPlan();
  }

  fetchSuscriptionPlan = async () => {
    try {
      await this.props
        .LoadSuscriptionPlan(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alert(this.props.error);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  handlePlanSelect = (plan) => {
    this.props.SetPlanValue(plan.value);
    this.props.history.push(
      plan.action === "onepay" ? "/panel/onepay" : "/panel/suscriptionpay"
    );
  };

  onClickRemoveSuscription = async () => {
    try {
      await this.props
        .RemoveSuscription(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alert(this.props.error);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const hasActivePlan = hasActiveSubscriptionPlan(this.props.suscription);

    return (
      <PanelLayout>
        <div className="subscription-plans">
          <header className="subscription-plans-header">
            <h1>
              <Translate value="suscription_mine" />
            </h1>
            <p>
              <Translate
                value={
                  hasActivePlan
                    ? "suscription_active_subtitle"
                    : "suscription_plans_subtitle"
                }
              />
            </p>
          </header>

          {hasActivePlan ? (
            <>
              <ActivePlanCard
                suscription={this.props.suscription}
                onUnsubscribe={this.onClickRemoveSuscription}
              />
              <div
                className="subscription-plans-advice"
                dangerouslySetInnerHTML={{
                  __html: I18n.t("advice_plan"),
                }}
              />
            </>
          ) : (
            <div className="subscription-plans-grid">
              {AVAILABLE_PLANS.map((plan) => (
                <PlanCard
                  key={plan.value}
                  plan={plan}
                  onSelect={this.handlePlanSelect}
                />
              ))}
            </div>
          )}
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    suscription: reducer.suscriptionPlan.item,
    error: reducer.suscriptionPlan.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  SetPlanValue: (value) =>
    dispatch(actions_suscription.setPlanValue({ value })),
  LoadSuscriptionPlan: (user_id, token) =>
    dispatch(actions_suscription.loadItem({ user_id, token })),
  RemoveSuscription: (user_id, token) =>
    dispatch(actions_suscription.deleteItem({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(MySuscription);
